module.exports = __webpack_public_path__ + "static/media/oca-logo.85e937c5.png";